export const LIST_TAXONOMY = 'LIST_TAXONOMY'
export const DETAIL_TAXONOMY = 'DETAIL_TAXONOMY'
export const MAKE_TREE_TAXONOMY = 'MAKE_TREE_TAXONOMY'
